import { Ref, RefBool } from "@tblabs/truffle";
import moment from "moment";
import { TimeUtils } from "../Utils/TimeUtils";


export class DateTimeProvider
{
    public static UseFakeSwitch = new RefBool(false);

    public static UseFake(nowIs: Date)
    {
        DateTimeProvider.UseFakeSwitch.value = true;
        DateTimeProvider._now.value = nowIs;
    }

    public static _now = new Ref<Date>(new Date())

    public static get Now(): Date
    {
        return DateTimeProvider.UseFakeSwitch.value ? DateTimeProvider._now.value : new Date();
    }

    public static set Now(v: Date)
    {
        this._now.value = v;
    }

    public static get NowAsString(): string
    {
        return `${moment(DateTimeProvider.Now).format("dddd")}, ${TimeUtils.FormattedDateTime(DateTimeProvider.Now)}`;
    }
}
